import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { api } from "../../api/api";
import { IComplaint } from "../../constants/commonTypes";
import { userRoles } from "../../contexts/AuthProvider/AuthProvider";
import { getUserAuth } from "../../helpers";
import {
  FETCH_USER_TRANSACTIONS_BY_DATE,
  FETCH_MECHANIC_COMPLAINTS,
  FETCH_TRANSACTIONS_LIST_PROGRESS,
  FETCH_TRANSACTIONS_LIST_SUCCESS,
  FETCH_TRANSACTIONS_LIST_FAILED,
} from "../constants";
import { IStoreState } from "../initialStoreState";
import { IMechanicDashboardAnalytics, IUserTransaction, IAnalyticsApiResponse, IAnalyticsTrasistionCount } from "./types";
import { IDate } from "../../components/Table/hooks/useDateFilter";

// Utility function to parse dynamic analytics API response
const parseAnalyticsResponse = (apiResponse: IAnalyticsApiResponse): IMechanicDashboardAnalytics => {
  const { totalRecords } = apiResponse;
  
  // Initialize with default values
  const analytics: IMechanicDashboardAnalytics = {
    totalComplaints: 0,
    totalComplaintCancelled: 0,
    totalComplaintsClosed: 0,
    totalComplaintsOpen: 0
  };

  // Parse the dynamic response
  totalRecords?.forEach((item) => {
    switch (item.status) {
      case "TOTAL":
        analytics.totalComplaints = item.status_count;
        break;
      case "CANCELLED":
        analytics.totalComplaintCancelled = item.status_count;
        break;
      case "CLOSED":
        analytics.totalComplaintsClosed = item.status_count;
        break;
      case "OPEN":
        analytics.totalComplaintsOpen = item.status_count;
        break;
      default:
        // Handle any unexpected status values
        console.warn(`Unknown status in analytics response: ${item.status}`);
        break;
    }
  });

  return analytics;
};

export const fetchTransactions = (
  key: string,
  list: IUserTransaction[],
  count: number
) => action(FETCH_USER_TRANSACTIONS_BY_DATE, { key, list, count });

export const fetchTransactionsAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    fromDate: string,
    toDate: string,
    status: "ACTIVE" | "PENDING",
    callBacks: {
      onStart: () => void;
      onSuccess: () => void;
      onError: (errMessage: string) => void;
    },
    role: keyof typeof userRoles,
    isNoRefereal: boolean,
    searchFilter?: string,
    searchValue?: string,
    realTime?: boolean,
    refresh?: boolean
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    // console.log(isNoRefereal, "no refereal");
    try {
      const key = fromDate + "-" + toDate + "-" + status;

      const token = getUserAuth();
      if (token) {
        callBacks.onStart();
        let url = `/dashboard-list-of-users-activated-or-pending?page=${pageNumber}&size=${rowsInPerPage}`;
        let filter;

    
        // if(searchFilter){
        //    filter =`&${searchFilter}=${searchValue}`;
        // }
        if (searchFilter && searchValue && searchFilter !== "-1") {
          // url = `/dashboard-list-of-users-activated-or-pending?&${searchFilter}=${searchValue.trim()}`;
          url = `/dashboard-list-of-users-activated-or-pending?page=${pageNumber}&size=${rowsInPerPage}&${searchFilter}=${searchValue.trim()}`;
        }

        // console.log("url", url);
        // console.log("searchFilter", searchFilter);
        // console.log("searchValue", searchValue);
let searchQuery = "";
        if (role === userRoles.SALES_TEAM_LEAD) {
          url = `/dashboard-list-of-leads-under-sales-team-lead?page=${pageNumber}&size=${rowsInPerPage}`;
          //  url += filter;
        }
        // if(realTime){
        //   searchQuery += `&real_time_v=${realTime?1:0}`;
        // }
        if (role === userRoles.SALES_TEAM_LEAD && isNoRefereal) {
          url = `/dashboard-list-of-users-activated-or-pending?page=${pageNumber}&size=${rowsInPerPage}`;
        }
        // if(searchFilter === "-1"){
          url = `${url}&from_date=${fromDate}&to_date=${toDate}&operation=LIST&status_v=${status}&real_time_v=${realTime?1:0}`
        // }

        const res = await api.get(url, {
          headers: {
            "auth-Token": token,
          },
        });

        dispatch(fetchTransactions(key, res.data, res.data.length));
        callBacks.onSuccess();
      }
    } catch (err) {
      callBacks.onError("");
    }
  };


  export const FETCH_MECHANIC_LIST_PROGRESS = "FETCH_MECHANIC_LIST_PROGRESS";
export const FETCH_MECHANIC_LIST_SUCCESS = "FETCH_MECHANIC_LIST_SUCCESS";
export const FETCH_MECHANIC_LIST_FAILED = "FETCH_MECHANIC_LIST_FAILED";


export const fetchMechanicListProgress = () =>
  action(FETCH_MECHANIC_LIST_PROGRESS);

export const fetchMechanicListSuccess = (
  list: IComplaint[],
  totalRecords: number,
  records:{
    currentRecords:number;
    totalPages:number;
    totalRecords:number;
  },
  amount:string
) => action(FETCH_MECHANIC_LIST_SUCCESS, { list, totalRecords, records, amount });

export const fetchMechanicListFailed = (error:string) => action(FETCH_MECHANIC_LIST_FAILED, {error});

// Transactions List Action Creators
export const fetchTransactionsListProgress = () =>
  action(FETCH_TRANSACTIONS_LIST_PROGRESS);

export const fetchTransactionsListSuccess = (
  list: IUserTransaction[],
  totalRecords: number,
  records: { currentRecords: number; totalPages: number; totalRecords: number },
  amount?: string
) => action(FETCH_TRANSACTIONS_LIST_SUCCESS, { list, totalRecords, records, amount });

export const fetchTransactionsListFailed = (error: string) => action(FETCH_TRANSACTIONS_LIST_FAILED, { error });

export const fetchMechanicListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string, 
    date?: IDate,
    searchValue?: string,
    searchType?: string[]
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchMechanicListProgress());
      let url = "";
      if (status !== "-1") {
        url = "&status=" + status;
      }
      let finalUrl =
        `/dashboard-complaint-assign-to-mechanic?pageNo=${pageNumber}&itemsPerPage=${rowsInPerPage}&from_date=${date?.fromDate}&to_date=${date?.toDate}` + url;

      const res = await api.get(finalUrl);
      const data: IComplaint[] = res.data.result;
      const totalRecords = res.data.totalRecords;
     

      dispatch(fetchMechanicListSuccess(data, totalRecords, {currentRecords:res.data.currentRecords, totalPages:res.data.totalPages, totalRecords:res.data.totalRecords}, res.data.totalAmount));
    } catch (error) {
      dispatch(fetchMechanicListFailed("Failed To fetch mechanic complaint data!"));
    }
  };

export const fetchTransactionsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    fromDate: string,
    toDate: string,
    status: "ACTIVE" | "PENDING",
    role: keyof typeof userRoles,
    isNoRefereal: boolean,
    searchFilter?: string,
    searchValue?: string,
    realTime?: boolean,
    refresh?: boolean
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchTransactionsListProgress());
      
      const token = getUserAuth();
      if (token) {
        let url = `/dashboard-list-of-users-activated-or-pending?page=${pageNumber}&size=${rowsInPerPage}`;
        let filter;

        if (searchFilter && searchValue && searchFilter !== "-1") {
          url = `/dashboard-list-of-users-activated-or-pending?page=${pageNumber}&size=${rowsInPerPage}&${searchFilter}=${searchValue.trim()}`;
        }

        let searchQuery = "";
        if (role === userRoles.SALES_TEAM_LEAD) {
          url = `/dashboard-list-of-leads-under-sales-team-lead?page=${pageNumber}&size=${rowsInPerPage}`;
        }
        
        if (role === userRoles.SALES_TEAM_LEAD && isNoRefereal) {
          url = `/dashboard-list-of-users-activated-or-pending?page=${pageNumber}&size=${rowsInPerPage}`;
        }
        
        url = `${url}&from_date=${fromDate}&to_date=${toDate}&operation=LIST&status_v=${status}&real_time_v=${realTime?1:0}`;

        const res = await api.get(url, {
          headers: {
            "auth-Token": token,
          },
        });

        const data: IUserTransaction[] = res.data;
        const totalRecords = res.data.length;
        const currentRecords = res.data.length;
        const totalPages = Math.ceil(totalRecords / rowsInPerPage);

        dispatch(fetchTransactionsListSuccess(
          data,
          totalRecords,
          {
            currentRecords,
            totalPages,
            totalRecords
          }
        ));
      }
    } catch (error) {
      dispatch(fetchTransactionsListFailed("Failed to fetch transactions data!"));
    }
  };


  export const FETCH_MECHANIC_DASHBOARD_ANALYTICS_PROGRESS = "FETCH_MECHANIC_DASHBOARD_ANALYTICS_PROGRESS";
  export const FETCH_MECHANIC_DASHBOARD_ANALYTICS_SUCCESS = "FETCH_MECHANIC_DASHBOARD_ANALYTICS_SUCCESS";
  export const FETCH_MECHANIC_DASHBOARD_ANALYTICS_FAILED = "FETCH_MECHANIC_DASHBOARD_ANALYTICS_FAILED";


  export const fetchMechanicDashboardAnalyticsProgress = () =>
    action(FETCH_MECHANIC_DASHBOARD_ANALYTICS_PROGRESS);
  export const fetchMechanicDashboardAnalyticsSuccess = (data: IMechanicDashboardAnalytics) =>
    action(FETCH_MECHANIC_DASHBOARD_ANALYTICS_SUCCESS, { data });
  export const fetchMechanicDashboardAnalyticsFailed = (error: string) =>
    action(FETCH_MECHANIC_DASHBOARD_ANALYTICS_FAILED, { error });


  export const MechanicDashboardAnalytics=(date:IDate, status?:string): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) =>{
      try {
        dispatch(fetchMechanicDashboardAnalyticsProgress());
        let url = "";
        if (status !== "-1") {
          url = "&status=" + status;
        }



        let finalUrl =
          `/dashboard-complaint-assign-to-mechanic-status-count?from_date=${date?.fromDate}&to_date=${date?.toDate}` + url;
  
        const res = await api.get(finalUrl);
        const apiResponse: IAnalyticsApiResponse = res.data;
        
        // Parse the dynamic response into our fixed structure
        const analyticsData = parseAnalyticsResponse(apiResponse);

        dispatch(fetchMechanicDashboardAnalyticsSuccess(analyticsData));
      } catch (error) {
        dispatch(fetchMechanicDashboardAnalyticsFailed("Failed To fetch mechanic complaint data!"));
      }


    }

    export const CLEAR_MECHANIC_ANALYTICS= "CLEAR_MECHANIC_ANALYTICS";
    export const clearMechanicAnalytics = () => action(CLEAR_MECHANIC_ANALYTICS);

export const fetchMechanicComplaints = (
  key: string,
  list: IComplaint[],
  count: number,
  amount:string
) => action(FETCH_MECHANIC_COMPLAINTS, { key, list, count, amount });

export const fetchMechanicComplaintsAsync =
  (
    fromDate: string,
    toDate: string,
    status: "OPEN" | "CLOSED",
    pageNo:number,
    itemsPerPage:number,
    callBacks: {
      onStart: () => void;
      onSuccess: () => void;
      onError: (errMessage: string) => void;
    },
    refresh?: boolean
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const key = fromDate + "-" + toDate + "-" + status;

      const token = getUserAuth();
      if (token) {
        callBacks.onStart();
        const res = await api.get(
          `/dashboard-complaint-assign-to-mechanic?from_date_v=${fromDate}&to_date_v=${toDate}&pageNo=${pageNo}&itemsPerPage=${itemsPerPage}&operation_name_v=LIST&status_v=${status}`,
          {
            headers: {
              "auth-Token": token,
            },
          }
        );

        dispatch(fetchMechanicComplaints(key, res.data, res.data.length, res.data.totalAmount));
        callBacks.onSuccess();
      }
    } catch (err) {
      callBacks.onError("");
    }
  };





  // Finance List Actions
  export const FETCH_FINANCE_LIST_PROGRESS = "FETCH_FINANCE_LIST_PROGRESS";
  export const FETCH_FINANCE_LIST_SUCCESS = "FETCH_FINANCE_LIST_SUCCESS";
  export const FETCH_FINANCE_LIST_FAILED = "FETCH_FINANCE_LIST_FAILED";

  export const fetchFinanceListProgress = () =>
    action(FETCH_FINANCE_LIST_PROGRESS);

  export const fetchFinanceListSuccess = (
    list: IUserTransaction[],
    totalRecords: number,
    totalAmount:number
  
  ) => action(FETCH_FINANCE_LIST_SUCCESS, { list, totalRecords,totalAmount });

  export const fetchFinanceListFailed = (error: string) =>
    action(FETCH_FINANCE_LIST_FAILED, { error });

  export const fetchFinanceListAsync =
    (
      pageNumber: number,
      rowsInPerPage: number,
      status: "ACTIVE" | "PENDING" | "-1",
      fromDate?: string,
      toDate?: string,
      searchFilter?: string,
      searchValue?: string,
      realTime?: boolean
    ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchFinanceListProgress());
        let url = `/dashboard-list-of-users-activated-or-pending-list?pageNo=${pageNumber}&itemsPerPage=${rowsInPerPage}`;
        if (status && status !== "-1") {
          url += `&status=${status}`;
        }
        if (fromDate) {
          url += `&from_date=${fromDate}`;
        }
        if (toDate) {
          url += `&to_date=${toDate}`;
        }
        if (searchFilter && searchValue && searchFilter !== "-1" && searchValue !=="-1") {
          url += `&${searchFilter}=${searchValue.trim()}`;
        }
        if (realTime) {
          url += `&real_time_v=${realTime?1:0}`;
        }
        const res = await api.get(url);
        const data: IUserTransaction[] = res.data.result || [];
        const totalRecords = res.data.totalRecords || 0;
        const totalAmount = res.data.totalAmount || 0;
     

        dispatch(fetchFinanceListSuccess(data, totalRecords,totalAmount));
      } catch (error) {
        dispatch(fetchFinanceListFailed("Failed to fetch finance list!"));
      }
    };
    



  // Finance Analytics Actions
  export const FETCH_FINANCE_ANALYTICS_PROGRESS = "FETCH_FINANCE_ANALYTICS_PROGRESS";
  export const FETCH_FINANCE_ANALYTICS_SUCCESS = "FETCH_FINANCE_ANALYTICS_SUCCESS";
  export const FETCH_FINANCE_ANALYTICS_FAILED = "FETCH_FINANCE_ANALYTICS_FAILED";

  export const fetchFinanceAnalyticsProgress = () =>
    action(FETCH_FINANCE_ANALYTICS_PROGRESS);
  export const fetchFinanceAnalyticsSuccess = (data: IAnalyticsTrasistionCount) =>
    action(FETCH_FINANCE_ANALYTICS_SUCCESS, { data });
  export const fetchFinanceAnalyticsFailed = (error: string) =>
    action(FETCH_FINANCE_ANALYTICS_FAILED, { error });

  export const fetchFinanceAnalyticsAsync =
    (
      status?: string,
      fromDate?: string,
      toDate?: string,
    ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchFinanceAnalyticsProgress());
        let url = `/dashboard-list-of-users-activated-or-pending-count2?`;
        if (fromDate) {
          url += `from_date=${fromDate}&`;
        }
        if (toDate) {
          url += `to_date=${toDate}&`;
        }
        if (status && status !== "-1") {
          url += `status=${status}&`;
        }
        // Remove trailing &
        url = url.replace(/&$/, "");

        const res = await api.get(url);
        const apiResponse: IAnalyticsTrasistionCount = res.data;

    

        dispatch(fetchFinanceAnalyticsSuccess(apiResponse));
      } catch (error) {
        dispatch(fetchFinanceAnalyticsFailed("Failed to fetch finance analytics!"));
      }
    };

  export const CLEAR_FINANCE_ANALYTICS = "CLEAR_FINANCE_ANALYTICS";
  export const clearFinanceAnalytics = () => action(CLEAR_FINANCE_ANALYTICS);

  export const FETCH_SALES_LEAD_LIST_PROGRESS = "FETCH_SALES_LEAD_LIST_PROGRESS";
  export const FETCH_SALES_LEAD_LIST_SUCCESS = "FETCH_SALES_LEAD_LIST_SUCCESS";
  export const FETCH_SALES_LEAD_LIST_FAILED = "FETCH_SALES_LEAD_LIST_FAILED";

  export const fetchSalesLeadListProgress = () =>
    action(FETCH_SALES_LEAD_LIST_PROGRESS);

  export const fetchSalesLeadListSuccess = (
    list: IUserTransaction[],
    totalRecords: number,
    totalAmount: number
  ) => action(FETCH_SALES_LEAD_LIST_SUCCESS, { list, totalRecords, totalAmount });

  export const fetchSalesLeadListFailed = (error: string) =>
    action(FETCH_SALES_LEAD_LIST_FAILED, { error });

  export const fetchSalesLeadListAsync =
    (
      pageNumber: number,
      rowsInPerPage: number,
      status: "ACTIVE" | "PENDING" | "-1",
      fromDate?: string,
      toDate?: string,
      searchFilter?: string,
      searchValue?: string,
      realTime?: boolean
    ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchSalesLeadListProgress());
        let url = `/dashboard-list-of-leads-under-sales-team-lead-list?pageNo=${pageNumber}&itemsPerPage=${rowsInPerPage}`;
        if (status && status !== "-1") {
          url += `&status=${status}`;
        }
        if (fromDate) {
          url += `&from_date=${fromDate}`;
        }
        if (toDate) {
          url += `&to_date=${toDate}`;
        }
        if (searchFilter && searchValue && searchFilter !== "-1" && searchValue !== "-1") {
          url += `&${searchFilter}=${searchValue.trim()}`;
        }
        if (realTime) {
          url += `&real_time_v=${realTime?1:0}`;
        }
        const res = await api.get(url);
        const data: IUserTransaction[] = res.data.result || [];
        const totalRecords = res.data.totalRecords || 0;
        const totalAmount = res.data.totalAmount || 0;

        dispatch(fetchSalesLeadListSuccess(data, totalRecords, totalAmount));
      } catch (error) {
        dispatch(fetchSalesLeadListFailed("Failed to fetch sales lead list!"));
      }
    };




    export const FETCH_SALES_LEAD_ANALYTICS_PROGRESS = "FETCH_SALES_LEAD_ANALYTICS_PROGRESS";
    export const FETCH_SALES_LEAD_ANALYTICS_SUCCESS = "FETCH_SALES_LEAD_ANALYTICS_SUCCESS";
    export const FETCH_SALES_LEAD_ANALYTICS_FAILED = "FETCH_SALES_LEAD_ANALYTICS_FAILED";
  
    export const fetchSalesLeadAnalyticsProgress = () =>
      action(FETCH_SALES_LEAD_ANALYTICS_PROGRESS);
    export const fetchSalesLeadAnalyticsSuccess = (data: IAnalyticsTrasistionCount) =>
      action(FETCH_SALES_LEAD_ANALYTICS_SUCCESS, { data });
    export const fetchSalesLeadAnalyticsFailed = (error: string) =>
      action(FETCH_SALES_LEAD_ANALYTICS_FAILED, { error });
  
    export const fetchSalesLeadAnalyticsAsync =
      (
        status?: string,
        fromDate?: string,
        toDate?: string,
      ): ThunkAction<void, IStoreState, {}, AnyAction> =>
      async (dispatch, getState) => {
        try {
          dispatch(fetchSalesLeadAnalyticsProgress());
          let url = `/dashboard-list-of-leads-under-sales-team-lead-count2?`;
          if (fromDate) {
            url += `from_date=${fromDate}&`;
          }
          if (toDate) {
            url += `to_date=${toDate}&`;
          }
          if (status && status !== "-1") {
            url += `status=${status}&`;
          }
          // Remove trailing &
          url = url.replace(/&$/, "");
  
          const res = await api.get(url);
          const apiResponse: IAnalyticsTrasistionCount = res.data;
  
          dispatch(fetchSalesLeadAnalyticsSuccess(apiResponse));
        } catch (error) {
          dispatch(fetchSalesLeadAnalyticsFailed("Failed to fetch sales lead analytics!"));
        }
      };


